/**
 * ProductsTab Component
 * Manages organization products and add-ons
 */
import "./documentsProductsAthletic.css";
import { Button } from "../../components/ui/button";
import { Plus, Edit, Trash2, Package } from "lucide-react";

const ProductsTab = ({ 
  products, 
  setEditingProduct,
  setProductData,
  setProductDialogOpen,
  handleDeleteProduct
}) => {
  const handleAddProduct = () => {
    setEditingProduct(null);
    setProductData({
      name: "", description: "", price: "", photo_url: "",
      has_sizes: false, sizes: [], has_colors: false, colors: []
    });
    setProductDialogOpen(true);
  };

  const handleEditProduct = (product) => {
    setEditingProduct(product);
    setProductData({
      name: product.name,
      description: product.description || "",
      price: product.price,
      photo_url: product.photo_url || "",
      has_sizes: product.sizes?.length > 0,
      sizes: product.sizes || [],
      has_colors: product.colors?.length > 0,
      colors: product.colors || []
    });
    setProductDialogOpen(true);
  };

  return (
    <div className="sh-documents-products" data-testid="products-tab">
      <div className="operational-panel">
        <div className="operational-header">
          <div>
            <h2 className="operational-heading">Products & Add-ons</h2>
            <p className="text-sm text-slate-500">
              Create reusable products that can be added to any program
            </p>
          </div>
          <Button
            onClick={handleAddProduct}
            className="operational-primary"
            data-testid="add-product-btn"
          >
            <Plus className="w-4 h-4 mr-2" />
            Add Product
          </Button>
        </div>

        {products.length > 0 ? (
          <div className="operational-list">
            {products.map((product) => (
              <div key={product.product_id} className="operational-row operational-product" data-testid={`product-${product.product_id}`}>
                <div className="operational-photo">
                  {product.photo_url ? (
                    <img src={product.photo_url} alt={product.name} className="w-full h-full object-cover" />
                  ) : (
                    <Package className="w-10 h-10 text-slate-400" />
                  )}
                </div>
                <div className="operational-product-body">
                  <div className="operational-row-content">
                    <div>
                      <p className="font-medium text-slate-900">{product.name}</p>
                      <p className="text-lg font-semibold text-slate-900">${product.price}</p>
                    </div>
                    <div className="operational-actions">
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleEditProduct(product)}
                        aria-label={`Edit ${product.name}`}
                      data-testid={`edit-product-${product.product_id}`}
                      >
                        <Edit className="w-4 h-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        className="text-red-600 hover:text-red-700"
                        onClick={() => handleDeleteProduct(product.product_id)}
                        aria-label={`Delete ${product.name}`}
                      data-testid={`delete-product-${product.product_id}`}
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                  {(product.sizes?.length > 0 || product.colors?.length > 0) && (
                    <div className="mt-2 flex gap-2 text-xs text-slate-500">
                      {product.sizes?.length > 0 && (
                        <span>{product.sizes.length} sizes</span>
                      )}
                      {product.colors?.length > 0 && (
                        <span>{product.colors.length} colors</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <Package className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <p className="text-slate-500 mb-4">No products yet. Create your first product.</p>
            <Button
              onClick={handleAddProduct}
              variant="outline"
              className="border-slate-300 rounded-full"
            >
              Create Product
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsTab;
